import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { api } from '@/lib/api';

export default function OAuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuthStore();
  const [error, setError] = useState('');

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const errorParam = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    if (errorParam) {
      setError(errorDescription || errorParam);
      setTimeout(() => navigate('/login'), 3000);
      return;
    }

    if (!code) {
      setError('Authorization code not found');
      setTimeout(() => navigate('/login'), 3000);
      return;
    }

    // Retrieve the provider we stored before redirecting
    const provider = localStorage.getItem('oauth_provider');
    if (!provider) {
      setError('OAuth provider not found. Please try again.');
      setTimeout(() => navigate('/login'), 3000);
      return;
    }

    // Exchange the code for tokens via the API
    api.get(`/api/v1/auth/${provider}/callback`, {
      params: { code, state },
    })
      .then((response) => {
        const { user, tokens } = response.data.data;

        localStorage.setItem('access_token', tokens.access_token);
        localStorage.setItem('refresh_token', tokens.refresh_token);
        localStorage.setItem('last_login_method', provider);
        localStorage.removeItem('oauth_provider');

        setUser(user);
        navigate('/dashboard');
      })
      .catch((err) => {
        const msg =
          err.response?.data?.message ||
          'Social authentication failed. Please try again.';
        setError(msg);
        localStorage.removeItem('oauth_provider');
        setTimeout(() => navigate('/login'), 3000);
      });
  }, [searchParams, navigate, setUser]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="max-w-md w-full p-8 bg-white rounded-lg shadow dark:bg-gray-800 text-center">
          <div className="text-red-500 text-lg font-semibold mb-2">Authentication Error</div>
          <p className="text-gray-600 dark:text-gray-400">{error}</p>
          <p className="text-sm text-gray-500 dark:text-gray-500 mt-4">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow dark:bg-gray-800 text-center">
        <div className="animate-spin h-8 w-8 border-4 border-brand-600 border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-gray-600 dark:text-gray-400">Completing sign in...</p>
      </div>
    </div>
  );
}
